module.exports = __webpack_public_path__ + "img/undraw_profile_details_re_ch9r.20e0954a.svg";